module.exports = __webpack_public_path__ + "assets/img/31.1e369e33.png";